import { Audiotype } from "../../containers/ccsmodule/queues/settings/componenets/audioType";
import { Queuetype } from "../../containers/ccsmodule/queues/settings/componenets/queueType";
import { ActiveSupervisorQueueType } from "../action-types/activeSupervisorQueue.action.types";
import { ActiveSupervisorQueueAction } from "../actions/activeSuperVisorQueue.action";

interface ActiveSupervisorQueueRepoState {
  active: Queuetype | {};
  currentTab: string;
  audio: Audiotype[];
  payload: Queuetype | {};
  clearFlag: boolean;
}

const initialState = {
  active: {},
  currentTab: "Queue",
  audio: [],
  payload: {},
  clearFlag: false,
};

const ActiveSupervisorQueueReducer = (
  state: ActiveSupervisorQueueRepoState = initialState,
  action: ActiveSupervisorQueueAction
): ActiveSupervisorQueueRepoState => {
  switch (action.type) {
    case ActiveSupervisorQueueType.SET_QUEUE:
      return {
        ...state,
        active: action?.payload,
      };
    case ActiveSupervisorQueueType.SET_CURRENTTAB:
      return {
        ...state,
        currentTab: action?.payload,
      };
    case ActiveSupervisorQueueType.SET_AUDIOLIB:
      return {
        ...state,
        audio: action?.payload,
      };
    case ActiveSupervisorQueueType.SET_PAYLOAD:
      return {
        ...state,
        payload: action?.payload,
      };
    case ActiveSupervisorQueueType.SET_CLEARFLAG:
      return {
        ...state,
        clearFlag: action?.payload,
      };
    default:
      return state;
  }
};

export default ActiveSupervisorQueueReducer;
